import React, { Component } from "react";
import PropTypes from "prop-types";

class DetailsCard extends Component {
    static propTypes = {
        items: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string,
                href: PropTypes.string
            })
        )
    };

    renderItem = ({ href, text }) => (
        <li key={text}>
            {href ? (
                <a className="details-card__link" href={href}>
                    {text}
                </a>
            ) : (
                <span dangerouslySetInnerHTML={{ __html: text }} />
            )}
        </li>
    );

    render() {
        const { items } = this.props;

        if (!items) {
            return null;
        }

        return <ul className="details-card">{items.map(this.renderItem)}</ul>;
    }
}

export default DetailsCard;



// WEBPACK FOOTER //
// ./src/scripts/components/DetailsCard.js